<template>
<div class="xin">
    <div class="switch">
        <el-tabs>
            <!-- 委派列表  -->
            <el-tab-pane label="委派列表">
                <span slot="label">
                    {{ $t("logs.delegata1") }}
                </span>
                <div class="switch1">

                    <div class="main">
                        <el-button @click="tan4()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.delegata3") }}</el-button>
                    </div>
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" v-loading="loading" >
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100">
                            </el-table-column>
                            <el-table-column prop="USERNAME" :label="$t('logs.autu5_a2')">
                            </el-table-column>
                            <el-table-column prop="DELEGATE_USER" :label="$t('logs.delegata2')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="100">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>
                                    <!-- 编辑 -->

                                    <el-button type="text" size="small" @click="save01(scope.$index, scope.row)" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <!-- 委派列表  -->
            <el-tab-pane label="">

            </el-tab-pane>
        </el-tabs>

        <div class="pop-up" v-show="tanchu" v-drag ="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.delegata3')}}</div>
                        <p></p>
            <div class="find">
                <div class="find1">
                    <div class="find-text" style="padding-right:12px">
                        {{ $t("logs.autu5_a2") }} :
                    </div>
                    <div class="block block1">
                        <el-input v-model="username" placeholder=""></el-input>
                    </div>
                </div>
                <div class="find1">
                    <div class="find-text" style="padding-right:12px">
                        {{ $t("logs.delegata2") }} :
                    </div>
                    <div class="block block1">
                        <el-input v-model="delegate_user" placeholder=""></el-input>
                    </div>
                </div>
            </div>

            <el-row>
                <el-button @click="save1()" :disabled="$root.jurisdiction.only_query == 0" type="primary">{{ $t("tab.save") }}</el-button>
                <el-button @click="tanOff()" type="danger">{{ $t("tab.cancel") }}</el-button>
            </el-row>
        </div>
        <div class="pop-up" v-show="tanchu1" v-loading="loading1" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.delegata3_edit')}}</div>
                        <p></p>
            <div class="find">
                <div class="find1">
                    <div class="find-text" style="padding-right:12px">
                        {{ $t("logs.autu5_a2") }}:
                    </div>
                    <div class="block block1">
                        <span style="color:#0E2C5E;font-size:14px">{{this.username1}}</span>
                    </div>
                </div>
                <div class="find1">
                    <div class="find-text" style="padding-right:12px">
                        {{ $t("logs.delegata2") }}:
                    </div>
                    <div class="block block1">
                        <el-input v-model="delegate_user" placeholder=""></el-input>
                    </div>
                </div>
            </div>

            <el-row>
                <el-button @click="save001()" type="primary" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                <el-button @click="tanOff1()" type="danger">{{ $t("tab.cancel") }}</el-button>
            </el-row>
        </div>
        <div class="gray" v-show="tanchu"></div>
        <div class="gray" v-show="tanchu1"></div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            // 条件
            username: "",
            username1: "",
            delegate_user: "",
            xian: false,
            btnText: "展示更多",
            checked: "",
            form: {
                username: "",
            },
            value: "",
            value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
            tanchu: false,
            tanchu1: false,
            poptime: [{
                    value: "选项1",
                    label: "所以节点",
                },
                {
                    value: "选项2",
                    label: "211.100.61.211",
                },
                {
                    value: "选项3",
                    label: "211.100.61.209",
                },
                {
                    value: "选项4",
                    label: "211.100.47.36",
                },
                {
                    value: "选项5",
                    label: "本机",
                },
            ],

            emali: "",
            fileList1: [],
            loading: false,
            loading1: false,
            bian_id: ''
        };
    },
    mounted() {
        this.getFileList1();
    },
    methods: {
        // 数据加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_alldelegate",
                        sid: sid,

                    },
                })
                .then((res) => {
                    console.log(res);

                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                        
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList1 = res.data.ret.datalist;

                    }
                })
             
        },
        // 委派列表保存
        save1() {
           
            // this.loading = true
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let username = this.username;
            let delegate_user = this.delegate_user;

            let str = this.$qs.stringify({
                __mode: "save_delegate",
                sid: sid,
                username: username,
                delegate_user: delegate_user,
                newadd: 1

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                         this.tanchu = false;
                        this.getFileList1();
                    }
                })
             
            this.real_code = "";
            this.real_addr = "";
        },
        // 委派列表删除
        handleClick1(index, scope) {
            console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let REAL_ADDR = scope.ID;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_delegate",
                                sid: sid,

                                id: REAL_ADDR,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList1();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        //委派列表编辑
        save01(index, scope) {
            this.tanchu1 = true;
            this.loading1 = true
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let ID = scope.ID;
            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "edit_delegate",
                        sid: sid,
                        id: ID,
                    },
                })
                .then((res) => {

                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading1 = false;

                        this.username1 = res.data.ret.datalist[0].USERNAME;
                        console.log(this.username1)
                        this.delegate_user = res.data.ret.datalist[0].DELEGATE_USER;
                        this.bian_id = res.data.ret.datalist[0].ID

                    }
                });
            // console.log(index, scope);
        },
        // 委派列表编辑保存
        save001() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let username = this.username1;
            let delegate_user = this.delegate_user;

            let str = this.$qs.stringify({
                __mode: "save_delegate",
                sid: sid,
                id: this.bian_id,
                username: username,
                delegate_user: delegate_user,
                newadd: 0
            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList1();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
            this.tanchu1 = false;

                        this.loading = false;
                        this.getFileList1();
                    }
                })
             
        },
        // 原始日志
        open() {
            this.$confirm(
                    "清空队列，将把所有队列邮件清空，并且不可恢复，您确定要做这个操作？",
                    "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "清除成功!",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消清空",
                    });
                });
        },
        tan2() {
            this.$confirm(
                    "清空deferred(延迟排队)队列，并且不可恢复，您确定要做这个操作？",
                    "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "清除成功!",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消清空",
                    });
                });
        },
        tan3() {
            this.$confirm("确定将队列全部重投吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "清除成功!",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消重投",
                    });
                });
        },
        tan5() {
            this.$confirm("确定重投所有选中的队列？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "重投成功!",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消重投",
                    });
                });
        },
        tan6() {
            this.$confirm("确定删除所有选中的队列？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "清除成功!",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消重投",
                    });
                });
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
            this.tanchu1 = false;
        },
        tan4: function () {
            this.tanchu = true;
            this.username = ''
            this.delegate_user = ''
            //   this.tanchu1 = false;
        },
        tanOff: function () {
            this.tanchu = false;
            //   this.tanchu1 = false;
        },
        tanOff1: function () {
            this.tanchu1 = false;
            //   this.tanchu1 = false;
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .has-gutter th:nth-child(1) {
    text-align: center;

}

/deep/ .has-gutter th:nth-child(4) {
    text-align: center;

}

// 表格居中位置
/deep/ .el-table__row td:nth-child(1) {
    text-align: center;

}

/deep/ .el-table__row td:nth-child(4) {
    text-align: center;

}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
</style>
